import { useTranslation } from 'react-i18next'
import { PageHeader } from '@/components/common/PageHeader'
import { useAuth } from '@/lib/auth/AuthProvider'
import { LoansSection } from './components/credit/LoansSection'
import { ReminderSettingsButton } from './components/credit/ReminderSettings'
import {
  FINANCE_LOAN_CREATE,
  FINANCE_LOAN_DELETE,
  FINANCE_LOAN_EDIT,
  FINANCE_LOAN_PAY,
  FINANCE_LOAN_UNPAY,
} from './permissions'

/** Şirket kredileri; her işlem (ekleme, ödeme, geri alma, düzeltme, silme) ayrı yetkiye bağlı. */
export function FinanceLoansPage() {
  const { t } = useTranslation()
  const { can } = useAuth()
  const perms = {
    create: can(FINANCE_LOAN_CREATE),
    pay: can(FINANCE_LOAN_PAY),
    unpay: can(FINANCE_LOAN_UNPAY),
    edit: can(FINANCE_LOAN_EDIT),
    delete: can(FINANCE_LOAN_DELETE),
  }
  return (
    <>
      <PageHeader
        eyebrow={t('nav.groups.finance')}
        title={t('finance.loans.title')}
        description={t('finance.loans.subtitle')}
        actions={<ReminderSettingsButton scope="company" size="default" />}
      />
      <LoansSection scope="company" perms={perms} />
    </>
  )
}
